import { Button } from '@/components/Elements';
import { Grid, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Content, InterviewInputProps } from '../types';

interface InterViewButtonsProps extends InterviewInputProps {
  contents: Content[];
  multiple?: boolean;
}

export const InterViewContentButtonGroup = (props: InterViewButtonsProps) => {
  const [selectId, setSelectId] = useState<number | number[] | null>(null);
  const [selectLabel, setSelectLabel] = useState<string | string[] | null>(null);

  useEffect(() => {
    // 選択が変わった時最新値に変更
    if (selectId && selectLabel) {
      props.onChange({
        ...props.answers,
        id: props.id,
        value: selectId,
        label: selectLabel
      });
    }
  }, [selectId, selectLabel]);

  return (
    <Grid container columns={12}>
      {props.contents.map((item, index) => (
        <Grid key={index} xs={6} item>
          {props.multiple ? (
            <InterViewContentMultipleButton
              id={item.id}
              label={item.label}
              key={index}
              selectId={selectId}
              setSelectId={setSelectId}
              selectLabel={selectLabel}
              setSelectLabel={setSelectLabel}
              multiple={props.multiple}
            ></InterViewContentMultipleButton>
          ) : (
            <InterViewContentButton
              id={item.id}
              label={item.label}
              key={index}
              selectId={selectId}
              setSelectId={setSelectId}
              selectLabel={selectLabel}
              setSelectLabel={setSelectLabel}
              multiple={props.multiple}
            />
          )}
        </Grid>
      ))}
    </Grid>
  );
};

type CustomButton = {
  id: number;
  label: string;
  selectId: number | number[] | null;
  setSelectId: React.Dispatch<React.SetStateAction<number | number[] | null>>;
  selectLabel: string | string[] | null;
  setSelectLabel: React.Dispatch<React.SetStateAction<string | string[] | null>>;
  multiple?: boolean;
};

// 一つ選択
const InterViewContentButton = (props: CustomButton) => {
  return (
    <Button
      className={`${
        props.id !== props.selectId ? 'border-primary bg-transparent' : 'bg-gray-300 border-[#D6D3D0]'
      } w-[90%] h-auto mx-auto my-1 py-2 text-sm border-2 font-semibold whitespace-nowrap`}
      onClick={() => {
        props.setSelectId(props.id);
        props.setSelectLabel(props.label);
      }}
    >
      <Typography className={`${props.id !== props.selectId ? 'text-primary' : 'text-[#424242]'} font-semibold`}>
        {props.label}
      </Typography>
    </Button>
  );
};

// 複数選択
const InterViewContentMultipleButton = (props: CustomButton) => {
  const [isSelect, setIsSelect] = useState<boolean>(false);
  return (
    <Button
      className={`w-[90%] h-auto mx-auto my-1 py-2 text-sm border-2 ${
        !isSelect ? 'border-primary bg-transparent' : 'bg-gray-300 border-[#D6D3D0]'
      } font-semibold whitespace-nowrap`}
      onClick={() => {
        if (Array.isArray(props.selectId) && Array.isArray(props.selectLabel)) {
          if (isSelect) {
            // 選択解除
            props.setSelectId(props.selectId.filter((id) => id !== props.id));
            props.setSelectLabel(props.selectLabel.filter((label) => label !== props.label));
          } else {
            // 選択
            props.setSelectId([...props.selectId, props.id]);
            props.setSelectLabel([...props.selectLabel, props.label]);
          }
        }
        setIsSelect(!isSelect);
      }}
    >
      <Typography className={`${!isSelect ? 'text-primary' : 'text-[#424242]'} font-semibold`}>
        {props.label}
      </Typography>
    </Button>
  );
};
